import { ArrowRight } from "lucide-react";

const steps = [
  { label: "Nog niet bemiddelbaar", note: "Meerdere leefgebieden onder druk" },
  { label: "LevelLeven", note: "Voorschakel-interventie", highlight: true },
  { label: "Voldoende toegerust", note: "Fundament aanwezig" },
  { label: "Werk · opleiding · participatie", note: "Reguliere vervolgstap" },
];

/**
 * Positionering: LevelLeven zit vóór arbeidsbemiddeling.
 * Nieuwe categorie: voorschakelinterventie.
 */
export default function VoorschakelDiagram() {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-9 gap-3 items-stretch">
        {steps.map((s, i) => (
          <div key={s.label} className="md:col-span-2 contents md:block">
            <div
              className={`h-full rounded-2xl p-6 border transition-colors ${
                s.highlight
                  ? "bg-[#1D2A22] text-[#FAF7F1] border-[#1D2A22]"
                  : "bg-[#FAF7F1] text-[#1D2A22] border-[#E5E1D8]"
              }`}
            >
              <p
                className={`text-xs uppercase tracking-[0.25em] mb-3 ${
                  s.highlight ? "text-[#D19B72]" : "text-[#E06B3F]"
                }`}
              >
                {String(i + 1).padStart(2, "0")}
              </p>
              <p className="font-heading text-xl sm:text-2xl leading-tight">
                {s.label}
              </p>
              <p
                className={`mt-2 text-xs ${
                  s.highlight ? "text-[#FAF7F1]/70" : "text-[#7A8276]"
                }`}
              >
                {s.note}
              </p>
            </div>
            {/* Arrow, alleen tussen kaarten */}
            {i < steps.length - 1 && (
              <div className="hidden md:flex md:col-span-0 items-center justify-center py-4">
                <ArrowRight className="text-[#E06B3F]" size={20} />
              </div>
            )}
          </div>
        ))}
      </div>
      <p className="mt-6 text-xs text-[#7A8276] italic max-w-2xl">
        Nieuw in het speelveld: <strong className="not-italic text-[#1D2A22] font-normal">voorschakel-interventie</strong>{" "}
       , geen re-integratie, geen zorg, wél de fase daartussen. Aanvullend op
        alles wat er al is.
      </p>
    </div>
  );
}
